import type Dexie from 'dexie';

let registeredDb: Dexie | null = null;

// Resolvers waiting on the db to be registered. On a hard reload the
// chat UI (silentBootstrap renders AppShell immediately) can mount and
// call `watchConversations`/`subscribeToMessages` BEFORE App.tsx's
// `installSync(db)` effect has finished its `await db.open()`. Rather
// than throw synchronously, web adapters await `whenWebDbReady()` and
// only set up their liveQuery once the db lands.
let readyResolvers: Array<(db: Dexie) => void> = [];

export function registerWebDb(db: Dexie): void {
  registeredDb = db;
  const resolvers = readyResolvers;
  readyResolvers = [];
  for (const resolve of resolvers) {
    resolve(db);
  }
}

export function getWebDb(): Dexie {
  if (!registeredDb) {
    throw new Error('Web db not registered. Call registerWebDb(db) before using web adapters.');
  }
  return registeredDb;
}

/**
 * Resolve once the web db is registered. Resolves immediately if it
 * already is. Use this from web adapters instead of `getWebDb()` when
 * the call site can run during the bootstrap race (see above).
 */
export function whenWebDbReady(): Promise<Dexie> {
  if (registeredDb) {
    return Promise.resolve(registeredDb);
  }
  return new Promise((resolve) => {
    readyResolvers.push(resolve);
  });
}
